<template>
    <div class="d-inline">
        <template v-if="showSelection">
            <v-chip v-for="(u, i) in selected" :key="i">
                {{ u.name }}({{ u.id }})
                <v-btn @click="unselect(i)" text color="error"><v-icon>$delete</v-icon></v-btn>
            </v-chip>
        </template>
        <span @click="show = true">
            <slot>
                <v-btn color="primary" dark class="d-inline-block mr-2">
                    请选择门店
                </v-btn>
            </slot>
        </span>

        <v-dialog v-model="show">
            <v-card>
                <list ref="shopselectorlist">
                    <template v-slot:actions="{ item }">
                        <v-btn v-if="selectedIds.includes(item.id)" @click="unselect(item)" color="error">取消选择</v-btn>
                        <v-btn v-else @click="select(item)">选择</v-btn>
                    </template>
                </list>
                <v-card-actions>
                    <v-btn @click="confirm" class="primary">确定</v-btn>
                    <v-btn @click="cancel">取消</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Table from './Table.vue'
export default {
    components: { List: Table },
    props: {
        multiple: { type: Boolean, default: false },
        showSelection: { type: Boolean, default: false },
        value: { type: Array, default: () => [] } //初始选择（之前已经选择）
    },
    data() {
        return {
            selected: [],
            show: false
        }
    },
    mounted() {
        // console.log('shopselector mounted', this.value)
        if (this.value && this.value.length > 0) {
            let ids = this.value.join(',')
            this.load(ids)
        }
    },
    watch: {
        value(nv, ov) {
            // console.log('shopselector watch value', nv, ov)
            if (nv && nv.length > 0) {
                let ids = nv.join(',')
                let oids = ov.join(',')
                console.log(ids, oids)
                if (ids !== oids) {
                    this.load(ids)
                }
            }
        }
    },
    computed: {
        selectedIds() {
            return this.selected.map((e) => e.id)
        }
    },
    methods: {
        load(ids) {
            this.$api.shop.getByIds(ids, (r) => {
                for (var i = 0; i < r.length; i++) {
                    this.addToSelected(r[i])
                }
            })
        },
        addToSelected(o) {
            let eindex = this.selected.findIndex((e) => e.id === o.id)
            if (eindex < 0) {
                this.selected.push(o)
            }
        },
        select(item) {
            if (this.multiple) {
                this.addToSelected(item)
            } else {
                this.selected = []
                this.addToSelected(item)
                this.show = false
                this.$emit('selected', this.selectedIds[0], this.selected[0])
            }
        },
        unselect(idx) {
            if (this.multiple) {
                this.selected.splice(idx, 1)
            } else {
                this.selected = []
                // this.selected.splice(idx, 1)
                // this.show = false
                // this.$emit('selected', this.selectedIds, this.selected)
            }
        },
        confirm() {
            this.show = false
            if (!this.multiple) {
                this.$emit('selected', this.selectedIds[0], this.selected[0])
            } else {
                this.$emit('selected', this.selectedIds, this.selected)
            }
        },
        cancel() {
            this.show = false
        }
    }
}
</script>
